/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import TransactionContainer from './dashboard/TransactionsContainer';
import EBillsContainer from './transaction/container/EBillsContainer';

function BillsContainer({ match }) {
  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">E-Bills Payment</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/bills"
          >
            Dashboard
          </NavLink>
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/bills/transaction"
          >
            Transaction
          </NavLink>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={TransactionContainer}
          />
          <Route
            path={`${match.path}/transaction`}
            component={EBillsContainer}
          />
        </Switch>
      </div>
    </>
  );
}

BillsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(BillsContainer);
